export const aprilAbbreviatedLowercase = "koKWWb";
export default {aprilAbbreviatedLowercase};